var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getOrganisationUsers from '../../requests/organisation/getOrganisationUsers';
/**
 *
 */
var GetOrganisationUsersCommand = /** @class */ (function (_super) {
    __extends(GetOrganisationUsersCommand, _super);
    function GetOrganisationUsersCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param userCollection UserCollection
     * @param inviteCollection InviteCollection
     * @return {*}
     */
    GetOrganisationUsersCommand.prototype.execute = function (organisation, userCollection, inviteCollection) {
        this.userCollection = userCollection;
        this.inviteCollection = inviteCollection;
        var promise = getOrganisationUsers(organisation);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    GetOrganisationUsersCommand.prototype.then = function (response) {
        this.userCollection.reset();
        this.userCollection.addAll(response.users);
        this.inviteCollection.reset();
        this.inviteCollection.addAll(response.pendingInvites);
    };
    return GetOrganisationUsersCommand;
}(Command));
export default GetOrganisationUsersCommand;
